import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { OpenModalHookType } from '@hooks/useOpenModal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface ModalConfirmDeactivationProps {
    modal: OpenModalHookType;
    serviceType: 'pickup' | 'delivery';
    onConfirm: (reason: string) => void;
}

export const ModalConfirmDeactivation: React.FunctionComponent<ModalConfirmDeactivationProps> = (props) => {
    const { modal, serviceType, onConfirm } = props;
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    const handleClose = () => {
        setReason('');
        setError('');
        modal.toggle();
    };

    const handleConfirm = () => {
        if (!reason.trim()) {
            setError('Motivo requerido');
            return;
        }
        onConfirm(reason.trim());
        handleClose();
    };

    useEffect(() => {
        if (modal.modalOpen) {
            setReason('');
            setError('');
        }
    }, [modal.modalOpen]);

    const serviceLabel = serviceType === 'pickup' ? 'Pickup' : 'Delivery';

    return (
        <Dialog
            PaperProps={{
                style: { borderRadius: 15, padding: 4 }
            }}
            open={modal.modalOpen}
            onClose={handleClose}
            aria-labelledby="modal-deactivation-title"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="modal-deactivation-title">
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack>
                        <Typography variant="h6" fontWeight={600}>
                            Apagar {serviceLabel}
                        </Typography>
                    </Stack>
                    <IconButton color="secondary" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ overflow: 'visible' }}>
                <Stack spacing={2}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Por favor, indique el motivo de inactividad del servicio {serviceLabel}.
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label="Motivo de inactividad"
                        variant="outlined"
                        value={reason}
                        onChange={(e) => {
                            setReason(e.target.value);
                            if (error) setError('');
                        }}
                        error={!!error}
                        helperText={error}
                        required
                        autoFocus
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button fullWidth color="primary" variant="contained" onClick={handleConfirm}>
                    Apagar
                </Button>
            </DialogActions>
        </Dialog>
    );
};
